import React from 'react'
import { RESULTS_META, RESULTS } from '../applyStrategies'

const LABEL_CLASSES = {
  [RESULTS.newDateOnly]: 'label label-success',
  [RESULTS.newDatePlusOffset]: 'label label-info',
  [RESULTS.inherited]: 'label label-primary',
  [RESULTS.unchanged]: 'label label-default',
  [RESULTS.offsetOnly]: 'label label-warning',
}

export function DueDate({ type, date, offsetText, offsetEmphasis }) {
  return <div>
    <div className='d-flex align-items-center justify-content-start'>
      <span className="mr-2">{date || 'N/A'}</span>
      <ResultType type={type} />
    </div>
    {offsetText &&
      <small className={offsetEmphasis ? 'due-dates-offset-emphasis' : 'text-muted'}>
        {offsetText}
      </small>
    }
  </div>
}

function ResultType({ type }) {
  const meta = RESULTS_META[type]
  if (!meta) return null
  return <span className={LABEL_CLASSES[type]} style={{ fontSize: '90%', padding: '5px 10px' }}>{meta.label}</span>
}
